var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boxInfo" }, [
    _c(
      "div",
      { staticClass: "addFormBox" },
      [
        _c(
          "el-button",
          {
            staticClass: "mb10",
            attrs: { size: "small", type: "primary", icon: "el-icon-plus" },
            on: { click: _vm.Add },
          },
          [_vm._v(_vm._s(_vm.$t("receivablePayable.AddRow")))]
        ),
        _c(
          "el-form",
          {
            ref: "tableForm",
            staticClass: "error-form",
            attrs: {
              model: _vm.formData,
              "label-width": "0px",
              rules: _vm.rules,
              size: "small",
            },
          },
          [
            _c(
              "virtual-scroll",
              {
                key: _vm.key,
                ref: "virtualScroll",
                attrs: {
                  data: _vm.formData.dataList,
                  "item-size": 76,
                  "key-prop": "key",
                },
                on: {
                  change: function (virtualList) {
                    return (_vm.list = virtualList)
                  },
                },
              },
              [
                _c(
                  "el-table",
                  {
                    ref: "tableRef",
                    staticClass: "table-height",
                    attrs: {
                      data: _vm.list,
                      "row-key": "key",
                      border: "",
                      height: _vm.tableHeightRow.height,
                      "highlight-current-row": false,
                    },
                  },
                  [
                    _c("virtual-column", {
                      attrs: { width: "80", type: "index" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: _vm.$t("receivablePayable.Month") },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("receivablePayable.Month"))
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.isNew
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "dataList." + scope.$index + ".month",
                                        rules: _vm.rules.month,
                                      },
                                    },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "month",
                                          "value-format": "yyyy-MM",
                                          placeholder: _vm.$t(
                                            "basicData.PleaseSelect"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeValidate(scope)
                                          },
                                        },
                                        model: {
                                          value: scope.row.month,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "month", $$v)
                                          },
                                          expression: "scope.row.month",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("span", [_vm._v(_vm._s(scope.row.month))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: _vm.$t("receivablePayable.Month") },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("receivablePayable.Currency"))
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.isNew
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "dataList." +
                                          scope.$index +
                                          ".currency",
                                        rules: _vm.rules.currency,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "basicData.PleaseSelect"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeValidate(scope)
                                            },
                                          },
                                          model: {
                                            value: scope.row.currency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "currency",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.currency",
                                          },
                                        },
                                        _vm._l(_vm.CURRENCY, function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.currency)),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: _vm.$t("basicData.exchangeRate") },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("basicData.exchangeRate"))
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.isNew
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "dataList." + scope.$index + ".rate",
                                        rules: _vm.rules.rate,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "basicData.PleaseSelect"
                                          ),
                                          clearable: "",
                                        },
                                        model: {
                                          value: scope.row.rate,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "rate", $$v)
                                          },
                                          expression: "scope.row.rate",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("span", [_vm._v(_vm._s(scope.row.rate))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("basicData.operate"),
                        width: "160",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  scope.row.id
                                    ? _c(
                                        "div",
                                        [
                                          !scope.row.isNew
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "5px",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handelEdit(
                                                        scope
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CenterForSorting.modify"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("el-popconfirm", {
                                    attrs: {
                                      title: _vm.$t(
                                        "basicData.AreYouSureYouWantToDelete"
                                      ),
                                    },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.handleDel(scope)
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "reference",
                                          fn: function () {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("basicData.Delete")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "addFooter" },
      [
        _c(
          "el-button",
          { attrs: { size: "small" }, on: { click: _vm.close } },
          [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
        ),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "permit",
                rawName: "v-permit:remove",
                value:
                  "btn:finance:reportDashboard:feishu:paymentDetails:exchangeRate",
                expression:
                  "'btn:finance:reportDashboard:feishu:paymentDetails:exchangeRate'",
                arg: "remove",
              },
            ],
            attrs: { size: "small", type: "primary" },
            on: { click: _vm.Save },
          },
          [_vm._v(_vm._s(_vm.$t("basicData.Save")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }